/* eslint-disable react-refresh/only-export-components -- context/provider file */
import React, { createContext, useContext, useMemo } from 'react';
import type { EoeClaimTabId } from './eoeClaimsManagerTabs';
import { EOEClaimsManagerTabContext } from './eoeClaimsManagerTabContext';

/** A selectable insurance/clinic option sourced from GET /billing-cycles/meta. */
export interface BillingOptionItem {
  id: string;
  name: string;
}

export interface EOEClaimsManagerOptions {
  insurances: BillingOptionItem[];
  clinics: BillingOptionItem[];
}

const EOEClaimsManagerOptionsContext = createContext<EOEClaimsManagerOptions>({
  insurances: [],
  clinics: [],
});

/** Read the agency-wide insurance/clinic option lists (populated from meta). */
export function useEOEClaimsManagerOptions(): EOEClaimsManagerOptions {
  return useContext(EOEClaimsManagerOptionsContext);
}

export function EOEClaimsManagerTabProvider({
  activeTabId,
  insurances = [],
  clinics = [],
  children,
}: {
  activeTabId: EoeClaimTabId;
  insurances?: BillingOptionItem[];
  clinics?: BillingOptionItem[];
  children: React.ReactNode;
}) {
  const options = useMemo<EOEClaimsManagerOptions>(
    () => ({ insurances, clinics }),
    [insurances, clinics]
  );
  return (
    <EOEClaimsManagerTabContext.Provider value={activeTabId}>
      <EOEClaimsManagerOptionsContext.Provider value={options}>
        {children}
      </EOEClaimsManagerOptionsContext.Provider>
    </EOEClaimsManagerTabContext.Provider>
  );
}
